module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_strengths_img01-fb49f4ec30d8abc9ef5ab1c53c2ea4a9.jpg";